import { forwardRef } from "react";
import { Icon, type IconProps } from "../Icon";

export const Chrome = forwardRef<SVGSVGElement, IconProps>((props, ref) => {
  return (
    <Icon ref={ref} {...props}>
      <circle cx="12" cy="12" r="10" />
      <circle cx="12" cy="12" r="4" />
      <path d="M21.17 8H12M3.95 6.06 8.54 14M10.88 21.94 15.46 14" />
    </Icon>
  );
});

Chrome.displayName = "Chrome";
